import React, { Component, Fragment } from "react";
import AppContext from "../../../contexts/AppContext";

class List extends Component {
    state = {
        item: {}
    };

    render() {
        return (
            <Fragment>
                <tr>
                    <td>{this.props.item.id}</td>
                    <td>
                        {this.props.item.first_name} {this.props.item.last_name}
                    </td>
                    <td className="large">{this.props.item.email}</td>
                    <td>
                        <time dateTime={this.props.item.created_at}>
                            {this.props.item.created_at}
                        </time>
                    </td>
                    <td> {this.props.item.data}</td>
                    <td> {this.props.item.email_verified}</td>
                    <td> {this.props.item.quiz}</td>
                    <td>
                        {this.props.item.complete
                            ? this.props.item.complete
                            : 0}
                        %
                    </td>
                    <td> {this.props.item.state}</td>
                </tr>
            </Fragment>
        );
    }
}
List.contextType = AppContext;
export default List;



// WEBPACK FOOTER //
// ./src/components/admin/members/List.js